import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ElectronService } from '../../../core/services/electron.service';

/**
 * Minimize / maximize / close for Windows, where Electron hides the native caption
 * (`titleBarStyle: 'hidden'`) and hands the whole top strip to the renderer. macOS keeps its
 * traffic lights and Linux its native frame, so this is never rendered on either.
 *
 * Sizing follows the Windows 11 caption metric (46dp wide buttons, full title-bar height) so the
 * hit targets land where the muscle memory expects them, while the colours come from the app
 * palette rather than the system one — the bar has to read as part of the app, not bolted on.
 */
@Component({
  selector: 'app-window-controls',
  templateUrl: './window-controls.component.html',
  styleUrl: './window-controls.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowControlsComponent {
  private readonly electron = inject(ElectronService);

  protected readonly isMaximized = this.electron.isMaximized;

  protected onMinimize(): void {
    this.electron.minimizeWindow();
  }

  protected onToggleMaximize(): void {
    this.electron.toggleMaximizeWindow();
  }

  protected onClose(): void {
    this.electron.closeWindow();
  }
}
